module.exports = __webpack_public_path__ + "578ca4b5e41d9019ab3bc51262acfdac.jpg";